import _get from 'lodash/get';
import {APPLICATION_STATUSES, FEATURES, HR_APPROVAL_STATUSES} from '@/utils/constants';
import getUserFeatures from '@/utils/user-features';

export function acceptedQuoteId(state) {
  return _get(state.application, 'metaData.acceptedQuote.id');
}

export function applicationComplete(state) {
  return state.application.applicationStatus === APPLICATION_STATUSES.complete;
}

export function hasSettlement(state) {
  return (
    applicationComplete(state) &&
    acceptedQuoteId(state) &&
    getUserFeatures()[FEATURES.settlement] &&
    _get(state.application, 'metaData.hrApproval') !== HR_APPROVAL_STATUSES.denied.value
  );
}

export function hasStartedApplication(state) {
  return Boolean(_get(state.application, 'applicationId'));
}

export function applicationQuoteIDs(state) {
  return _get(state.application, 'metaData.quotes') || [];
}

export function applicationCreditCheckId(state) {
  return _get(state.application, 'metaData.creditCheckId');
}

export function creditCheckComplete(state) {
  return _get(state.application, 'metaData.creditCheckCompleted');
}

export function creditCheckStatus(state) {
  return _get(state.application, 'metaData.creditCheckStatus');
}

export function hrRequestSent(state) {
  return _get(state.application, 'metaData.hrApprovalRequestSent');
}

export function hasAnyQuote(state) {
  return Boolean(applicationQuoteIDs(state).length);
}
